import { render } from "./StatisticheValidatori.vue?vue&type=template&id=0a680bea&scoped=true"
import script from "./StatisticheValidatori.vue?vue&type=script&lang=js"
export * from "./StatisticheValidatori.vue?vue&type=script&lang=js"

import "./StatisticheValidatori.vue?vue&type=style&index=0&id=0a680bea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a680bea"]])

export default __exports__